import React from 'react';

const Blogs = () => {
    return (
        <div className='w-50 mx-auto pt-4'>
            <div>
                <h4>1. What is Context API?</h4>
                <p>The React Context API is a way to pass data from grandparent to child to parent without props drilling. In this way, we can be moving props globally and access where ever we want.</p>
            </div>
            <div>
                <h4>2. What is Semantic?</h4>
                <p>Semantic HTML elements are those that clearly describe their meaning in a human- and machine-readable way.there are some benefits of semantic elements. it is much easier to read.It has greater accessibility.Overall, semantic elements also lead to more consistent code.</p>
                <p><strong>Here are some Semantic example: </strong> article, aside, details, figcaption, figure, footer, header, main, mark, nav, section, summary, time, </p>
            </div>
        </div>
    );
};

export default Blogs;